import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  OutlinedInput,
  Grid,
  Typography,
  FormControl,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { useStyles, ProfileLogic, validator } from "./profile.module";
import ButtonDefault from "../shared/button/button";
import InputBase from "@material-ui/core/InputBase";
import Flags from "../../classes/Flags/Flags";
import "antd/dist/antd.css";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import "date-fns";
import {
  ProfileVerifyLogic,
  validateVerifyInformation,
} from "./profile.module";
import "date-fns";
import AlertMessage from "../shared/alert/alert";
import "./custom-styles.css";
import "antd/dist/antd.css";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const VerifyInformationAccordion = () => {
  const { current, changeState, handleChange } = ProfileLogic(() => validator);

  const {
    formData,
    handleChangeForm,
    handleChangeDate,
    handleChangeCountry,
    buttonDisabledVerify,
    name,
    lastname,
    handleVerifySubmit,
    showSuccess,
    errors,
    translator,
  } = ProfileVerifyLogic(validateVerifyInformation);
  const classes = useStyles();

  return (
    <Accordion onChange={changeState(0)}>
      <AccordionSummary
        className={classes.root}
        expandIcon={
          current === 0 ? (
            <RemoveCircleOutlineIcon
              className={classes.removeCircleOutlineIcon}
            />
          ) : (
            <AddCircleOutlineIcon className={classes.addCircleOutlineIcon} />
          )
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography variant="h5" className={classes.questionsWhite}>
          {translator("verify_title")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid
            item
            lg={6}
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <FormControl fullWidth>
              <label className={classes.labels}>
                {translator("verify_name")}
              </label>
              <OutlinedInput
                className={classes.outlinedInputProfile}
                type="text"
                value={name}
                name="firstName"
                onChange={handleChange}
                disabled={true}
              />
            </FormControl>
          </Grid>

          <Grid
            item
            lg={6}
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <FormControl fullWidth>
              <label className={classes.labels}>
                {translator("verify_lastName")}
              </label>
              <OutlinedInput
                className={classes.outlinedInputProfile}
                value={lastname}
                name={"confirmNewPassword"}
                onChange={handleChange}
                labelWidth={30}
                disabled={true}
              />
            </FormControl>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Grid container direction="column" alignItems="flex-start">
              <label className={classes.labels}>
                {translator("verify_date")}
              </label>
              <Grid item className={classes.datePickerContainer}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="dialog"
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    value={
                      formData && formData.dateOfBirth
                        ? new Date(formData.dateOfBirth)
                        : null
                    }
                    onChange={handleChangeDate}
                    name="dateOfBirth"
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                      className: classes.icon,
                    }}
                    className={classes.datePickerInput}
                    DialogProps={{
                      className: classes.pickerDialogPaper,
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
              paddingLeft: "5px",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <label className={classes.labels}>
              {translator("verify_address")}
            </label>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  value={formData?.address || ""}
                  onChange={handleChangeForm}
                  name="address"
                  placeholder={translator("verify_addressTwo")}
                />
              </FormControl>
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  value={formData?.unit || ""}
                  onChange={handleChangeForm}
                  name="unit"
                  placeholder={translator("verify_unit")}
                />
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  value={formData?.locality || ""}
                  onChange={handleChangeForm}
                  name="locality"
                  placeholder={translator("verify_town")}
                />
              </FormControl>
            </Grid>

            <Grid item lg={7} md={7} sm={7} xs={12}>
              <FormControl fullWidth>
                <OutlinedInput
                  className={classes.outlinedInputProfile}
                  value={formData?.postalCode || ""}
                  onChange={handleChangeForm}
                  name="postalCode"
                  placeholder={translator("verify_postal")}
                />
              </FormControl>
            </Grid>

            <Grid item lg={5} md={5} sm={5} xs={12}>
              <Autocomplete
                className={classes.dropdownOption}
                align="left"
                fullWidth
                id="free-solo-demo"
                freeSolo
                onChange={handleChangeCountry}
                options={Flags.flagDataArray()}
                getOptionLabel={(option) => option.label}
                renderOption={(option) => (
                  <Grid container alignItems="center">
                    <img
                      src={option.flag}
                      alt={option.label}
                      style={{ width: 35, height: 30, marginRight: 15 }}
                    />
                    {option.label}
                  </Grid>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={translator("verify_select_country")}
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                    }}
                  />
                )}
                getOptionSelected={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <label className={classes.labels}>
              {translator("verify_labels")}
            </label>
            <TextField
              value={formData?.whyEgreen || ""}
              onChange={handleChangeForm}
              className={classes.profileSelect}
              name="whyEgreen"
              input={<BootstrapInput />}
              align="left"
              fullWidth
              color="theme.palette.text.tertiary"
              select
              variant="outlined"
              required
              SelectProps={{
                MenuProps: {
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    sx: {
                      width: "auto",
                      minWidth: "100%",
                    },
                  },
                },
              }}
            >
              <MenuItem value="" className={classes.menuItemProfile}>
                <em>{translator("verify_em")}</em>{" "}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="learn_about_manage_emissions"
              >
                {translator("verify_learn")}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="offset_carbon_footprint"
              >
                {translator("verify_offset")}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="support_carbon_projects"
              >
                {translator("verify_support")}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="explore_climate_projects"
              >
                {translator("verify_explore")}
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <label className={classes.labels}>
              {translator("verify_income")}
            </label>
            <TextField
              value={formData?.sourceIncome || ""}
              onChange={handleChangeForm}
              name="sourceIncome"
              className={classes.profileSelect}
              input={<BootstrapInput />}
              align="left"
              fullWidth
              color="theme.palette.text.tertiary"
              select
              variant="outlined"
              required
              SelectProps={{
                MenuProps: {
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    sx: {
                      width: "auto",
                      minWidth: "100%",
                    },
                  },
                },
              }}
            >
              <MenuItem className={classes.menuItemProfile} value="">
                <em>{translator("verify_select")}</em>{" "}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="sustainability"
              >
                {translator("verify_sustainability")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="tech">
                {translator("verify_tech")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="finance">
                {translator("verify_finance")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="public">
                {translator("verify_public")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="ngo">
                {translator("verify_ngo")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="agriculture">
                {translator("verify_agriculture")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="transport">
                {translator("verify_transport")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="energy">
                {translator("verify_energy")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="other">
                {translator("verify_other")}
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "2px",
              flexDirection: "column",
            }}
          >
            <label className={classes.labels}>
              {translator("verify_labelEmployment")}
            </label>
            <TextField
              value={formData?.employmentStatus || ""}
              onChange={handleChangeForm}
              name="employmentStatus"
              align="left"
              input={<BootstrapInput />}
              fullWidth
              className={classes.profileSelect}
              color="theme.palette.text.tertiary"
              select
              variant="outlined"
              required
              SelectProps={{
                MenuProps: {
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    sx: {
                      width: "auto",
                      minWidth: "100%",
                    },
                  },
                },
              }}
            >
              <MenuItem className={classes.menuItemProfile} value="">
                <em>{translator("verify_selectEmployment")}</em>{" "}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="full_time">
                {translator("verify_fullTime")}
              </MenuItem>
              <MenuItem
                className={classes.menuItemProfile}
                value="self_employed"
              >
                {translator("verify_selfEmployed")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="student">
                {translator("verify_student")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="academic">
                {translator("verify_academic")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="non_profit">
                {translator("verify_nonProfit")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="government">
                {translator("verify_government")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="landowner">
                {translator("verify_landowner")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="retired">
                {translator("verify_retired")}
              </MenuItem>
              <MenuItem className={classes.menuItemProfile} value="other">
                {translator("verify_other")}
              </MenuItem>
            </TextField>
          </Grid>

          <Grid container justifyContent="center" alignItems="center">
            <div className={classes.container}>
              <ButtonDefault
                type="blue"
                text={translator("verify_continue")}
                changeView={handleVerifySubmit}
                disabled={buttonDisabledVerify}
                align="center"
              ></ButtonDefault>

              {showSuccess && (
                <AlertMessage
                  text={translator("verify_alertMessage")}
                  type={"success"}
                  className={classes.alertMessage}
                />
              )}
            </div>
            {errors &&
              Object.keys(errors).length > 0 &&
              Object.keys(errors).map((errorKey) => (
                <AlertMessage
                  key={errorKey}
                  type="error"
                  text={
                    Array.isArray(errors[errorKey])
                      ? errors[errorKey].join(", ")
                      : typeof errors[errorKey] === "object"
                      ? JSON.stringify(errors[errorKey])
                      : errors[errorKey]
                  }
                />
              ))}
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default VerifyInformationAccordion;
